import { getTimeOffset } from "@website/utils/time-sync-utils";

export const SERVER_NOW = () => Date.now();
export const getNow = () => {
  const offset = getTimeOffset();
  return Date.now() + (offset ? Number(offset) : 0);
};
